import Splide from "@splidejs/splide";

export default () => {
    const offerSlider = document.querySelector(".offer-images-slider");
    const offerThumbnailSlider = document.querySelector(".offer-thumbnail-slider");

    if (!offerSlider || !offerThumbnailSlider) return;

    const main = new Splide(offerSlider, {
        type: "fade",
        rewind: true,
        pagination: false,
        arrows: false,
    });

    const thumbnails = new Splide(offerThumbnailSlider, {
        fixedHeight: 100,
        gap: 10,
        rewind: true,
        pagination: false,
        isNavigation: true,
        perPage: 6,
        breakpoints: {
            600: {
                perPage: 0,
            },
        },
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();

};